"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppUid = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useAppUid = () => {
    const [appUid, setAppUid] = (0, react_1.useState)(null);
    const history = (0, react_router_dom_1.useHistory)();
    (0, react_1.useEffect)(() => {
        try {
            const currentUrl = new URL(window.location.href);
            const urlParams = new URLSearchParams(currentUrl.search);
            const urlAppUid = urlParams.get('app_uid');
            if (urlAppUid) {
                localStorage.setItem('app_uid', urlAppUid);
                setAppUid(urlAppUid);
                urlParams.delete('app_uid');
                const newSearch = urlParams.toString();
                const newPath = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}`;
                history.replace(newPath);
            }
            else {
                const storedAppUid = localStorage.getItem('app_uid');
                setAppUid(storedAppUid);
            }
        }
        catch (error) {
            console.error('Error handling app_uid:', error);
        }
    }, [history]);
    (0, react_1.useEffect)(() => {
        const handleStorageChange = (event) => {
            if (event.key === 'app_uid') {
                setAppUid(event.newValue);
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);
    const transformBookingUrl = (0, react_1.useCallback)((url) => {
        if (!url || !appUid) {
            return url;
        }
        if (!url.includes('https://portal.smart-checkin.at/INNGuest/loading')) {
            return url;
        }
        if (url.includes(`/loading/${appUid}`)) {
            return url;
        }
        const baseUrl = url.endsWith('/') ? url : `${url}/`;
        return `${baseUrl}${appUid}`;
    }, [appUid]);
    return transformBookingUrl;
};
exports.useAppUid = useAppUid;
